import { render, staticRenderFns } from "./BusAssetStorageDetailModal.vue?vue&type=template&id=923f4766&"
import script from "./BusAssetStorageDetailModal.vue?vue&type=script&lang=js&"
export * from "./BusAssetStorageDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports